<template>
  <div class="container">
    <div v-if="!list.length" class="noList">暂无数据！</div>
    <dl v-for="item in list" :key="item.id">
      <div class="top">
        <div class="title">
          <img src="@/assets/chuan.png" alt="" />
          <h3>{{ item.oilShipCode }}</h3>
        </div>
        <div class="option">
          <!-- <img src="" alt=""> -->
          <p
            class="status"
            :class="
              item.isFail ? 'fail' : item.status == 1 ? 'wait' : 'success'
            "
          >
            {{
              item.isFail ? "已失效" : item.status == 1 ? "待加油" : "已加油"
            }}
          </p>
        </div>
      </div>

      <div class="details">
        <div class="info">
          <p>
            <span>加油数量：</span>
            {{ item.appointQuantity }}{{ item.quantityUnitName }}
          </p>
          <p>
            <span>加油时间：</span>
            {{ item.time }}
          </p>
          <p>
            <span>我的渔船：</span>
            {{ item.shipCode }}
          </p>
        </div>
        <div v-if="item.today" class="button" @click="lookMap(item.id)">
          查看位置
        </div>
      </div>
    </dl>
  </div>
</template>
<script>
import { getAppointHistory } from "@/api/oilAppoint";
import { dateFormat } from "@/utils/date2";
export default {
  data() {
    return {
      list: []
    };
  },
  mounted() {
    const { id } = this.$route.params;
    this.getData(id);
  },
  methods: {
    getData(id) {
      this.$vux.loading.show();
      const today = dateFormat(new Date(), "yyyy-MM-dd");
      console.log(today);
      getAppointHistory({ id })
        .then(res => {
          this.list = res.map(item => {
            if (today === item.appointTime.substr(0, 10)) {
              item.today = true;
              item.time = "今天 " + item.appointTime.substr(11);
            } else {
              item.today = false;
              item.time = item.appointTime;
            }
            if (
              Number(dateFormat(new Date(), "yyyyMMdd")) >
              Number(dateFormat(new Date(item.appointTime), "yyyyMMdd"))
            ) {
              item.isFail = true;
            } else {
              item.false = true;
            }
            return item;
          });
          this.$vux.loading.hide();
        })
        .catch(err => {
          this.$vux.loading.hide();
          this.freshLoading = false;
          this.$showError(err, "warn");
        });
    },
    // 前往地图
    lookMap(id) {
      this.$router.push({
        path: `/order/oilAppointMap/${id}`
      });
    }
  }
};
</script>

<style lang="less" scoped>
.noList {
  position: fixed;
  top: 30%;
  left: 50%;
  margin-left: -100px;
  width: 200px;
  text-align: center;
  font-size: 20px;
  color: #111;
}
.container {
  width: 100%;
  min-height: calc(100vh - 60px);
  margin: 30px auto;
  background: #f5f5f5;
  dl {
    width: 90%;
    margin: 30px auto 0;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 10px 30px 5px rgba(0, 0, 0, 0.2);
    padding: 8px 0 10px;
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 30px;
      .title {
        display: flex;
        align-items: center;
        margin-left: 30px;
        img {
          width: 35px;
          height: 35px;
        }
        h3 {
          font-size: 16px;
          color: #111;
          font-weight: 500;
          margin-left: 20px;
        }
      }
      .option {
        display: flex;
        align-items: center;
        img {
          width: 30px;
          height: 30px;
          background: #000;
          margin-right: 40px;
        }
        .status {
          font-size: 14px;
          color: #fff;
          padding: 5px 20px;
          border-top-left-radius: 20px;
          border-bottom-left-radius: 20px;
        }
        .fail {
          background: #d2d2d2;
        }
        .wait {
          background: #f9bd2b;
        }
        .success {
          background: #27d124;
        }
      }
    }
    .details {
      width: calc(100% - 60px);
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 30px auto;
      padding-top: 30px;
      border-top: 1px solid #e5e5e5;
      .info {
        font-size: 14px;
        color: rgb(27, 25, 25);
        span {
          color: #767676;
        }
      }
      .info p:nth-of-type(1) {
        margin-bottom: 8px;
      }
      .info p:nth-of-type(3) {
        margin-top: 8px;
      }
      .button {
        padding: 10px 20px;
        border-radius: 8px;
        font-size: 16px;
        color: #fff;
        text-align: center;
        background: #409afb;
      }
    }
  }
}
</style>
